import {
  renderDiagnostic,
  renderDiagnosticForNew,
  validateDiagnostic,
  validateDiagnosticForNew,
} from 'saas/pco/cases/api';
import { getIsFetching, getValues } from '../reducers/diagnostic';
import { fetchTools } from './tools';

export const FETCH_DIAGNOSTIC = 'case.FETCH_DIAGNOSTIC';
export const FETCH_DIAGNOSTIC_SUCCESS = 'case.FETCH_DIAGNOSTIC_SUCCESS';
export const SERIALIZE_DIAGNOSTIC = 'case.SERIALIZE_DIAGNOSTIC';
export const SERIALIZE_ERRORS = 'case.SERIALIZE_ERRORS';

const requestDiagnostic = (site, diagnostic) => ({
  type: FETCH_DIAGNOSTIC,
  site,
  diagnostic,
});

const receiveDiagnostic = (site, diagnostic, content) => ({
  type: FETCH_DIAGNOSTIC_SUCCESS,
  site,
  diagnostic,
  content,
});

// TODO: Find a way to avoid performing validation when data has not changed
export const fetchDiagnostic = (siteCase, type, site) => (
  dispatch,
  getState
) => {
  const state = getState();

  if (getIsFetching(state, site).has(type)) {
    return Promise.resolve();
  }

  dispatch(requestDiagnostic(site, type));

  let promise;

  const values = getValues(state, site).get(type);
  if (values) {
    promise =
      state.siteCase.requirements && state.siteCase.requirements.isNew
        ? validateDiagnosticForNew(type, values)
        : validateDiagnostic(type, values);
  } else if (state.siteCase.requirements && state.siteCase.requirements.isNew) {
    // Fetching tools on initial render
    promise = renderDiagnosticForNew(type, site).then(content => {
      dispatch(fetchTools(siteCase, type, site));
      return content;
    });
  } else {
    promise = renderDiagnostic(siteCase, type, site).then(content => {
      dispatch(fetchTools(siteCase, type, site));
      return content;
    });
  }

  return promise.then(content =>
    dispatch(receiveDiagnostic(site, type, content))
  );
};

export const serializeDiagnostic = (type, site, form, hasChanges = true) => ({
  type: SERIALIZE_DIAGNOSTIC,
  site,
  diagnostic: type,
  values: form,
  hasChanges,
});

export const serializeErrors = errors => ({
  type: SERIALIZE_ERRORS,
  errors,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/actions/diagnostic.js